import { useMutation } from '@apollo/client';

import { DELETE_IMAGE } from '../graphql/mutation/deleteImageMutation.graphql';
import { CURRENT_USER } from '../graphql/query/currentUserQuery.graphql';

export const useDeleteImageMutation = () => {
  const [mutate] = useMutation(DELETE_IMAGE);

  const deleteImage = (id: string) => {
    mutate({
      variables: {
        id,
      },
      refetchQueries: [CURRENT_USER],
    });
  };

  return { deleteImage };
};
